"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../index");

exports.displayPrice = function (price) {
  try {
    var currencyString = price.currency === "USD" ? "$" : price.currency;
    return typeof price.amount === "number" && price.amount > 0 ? "" + currencyString + index_1.numberWithCommas(Number(price.amount.toFixed(2))) : "";
  } catch (error) {
    return "";
  }
};

exports.normalizePriceAmount = function (priceAmount) {
  try {
    var matched = priceAmount.match(/\d+/g);

    if (matched) {
      return Number(matched.toString());
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

exports.addPrices = function (prices) {
  var total = {
    amount: 0,
    currency: "USD"
  };

  for (var _i = 0, prices_1 = prices; _i < prices_1.length; _i++) {
    var price = prices_1[_i];
    total.amount += price.amount;
  }

  return total;
};

exports.subtractPrices = function (price1, price2) {
  return {
    currency: price1.currency,
    amount: price1.amount - price2.amount
  };
};